export default __webpack_public_path__ + "static/media/teeth - inactive_v1.3af22447.svg";